import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgFreehand(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 -4 16 24" {...props}>
      <path
        d="M14.005 3.054a1 1 0 01-.297-.835c.166-1.407 1.337-1.438 3.107-.884a1 1 0 01.15 1.848c1.103 1.139 1.89 2.053 2.37 2.754 1 1.466.987 2.949-.833 2.96-.678.003-.639.012-4.273-.893a97.466 97.466 0 00-.831-.204c-1.758-.421-2.96-.634-3.732-.629h-.051c.329.595.762 1.205 1.308 1.864.373.452 1.706 1.92 1.925 2.2.365.464.549.796.542 1.244-.012.855-.658 1.2-1.418 1.204-1.572.01-4.958.723-5.283 1.05a1 1 0 11-1.419-1.41c.673-.677 3.31-1.332 5.389-1.557-.454-.51-1.026-1.152-1.277-1.456-.705-.85-1.258-1.648-1.675-2.467-.835-1.641.212-2.661 1.947-2.672.986-.006 2.297.226 4.21.684.262.063.536.13.849.208 1.39.347 2.21.55 2.729.67-.652-.858-1.802-2.092-3.437-3.679z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Freehand')(SvgFreehand);
